import React, { useEffect, useState } from 'react';
import './BrandsModelsManager.css';
import ModalCadastroMarca from './ModalCadastroMarca';
import ModalCadastroModelo from './ModalCadastroModelo';
import Conect from '../../services/api/Conect';
import NotificationsAlert from '../../services/NotificationsAlert';
import { LuRefreshCcw } from "react-icons/lu";

const BrandsModelsManager = () => {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [showModalMarca, setShowModalMarca] = useState(false);
  const [showModalModelo, setShowModalModelo] = useState(false);

  useEffect(() => {
    fetchBrands();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedBrand) {
      fetchModels(selectedBrand.id);
    } else {
      setModels([]);
    }
  }, [selectedBrand]);

  const fetchBrands = async () => {
    const token = localStorage.getItem("fptoken");

    try {
      const response = await Conect.get(`/listallbrands${token}`);

      if (!response.data.erro) {
        setBrands(response.data.data);
        fetchModels("all")
        setSelectedBrand(null);
        return;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchModels = async (brandId) => {
    const token = localStorage.getItem("fptoken");
    try {
      if (brandId === "all") {
        const response = await Conect.get(`/listallmodels${token}`);
        if (!response.data.erro) {
          setModels(response.data.data);
          return;
        }
      } else {
        const response = await Conect.post(`/listmodelwherebrand${token}`, {
          brand_id: Number(brandId)
        });

        if (!response.data.erro) {
          setModels(response.data.data);
          return;
        }
      }

    } catch (error) {
      console.error("Error:", error);
    }
    // setModels(data);
  };

  const handleSaveMarca = async (nome) => {

    const token = localStorage.getItem("fptoken");

    const normalizedName = normalizeText(nome);

    /* VALIDAÇÃO */
    const alreadyExists = brands.some(
      (brand) =>
        normalizeText(brand.name) === normalizedName
    );

    if (alreadyExists) {
      NotificationsAlert(
        "warning",
        "",
        "Esta marca já está cadastrada."
      );

      return;
    }

    try {

      const response = await Conect.post(
        `/createbrand${token}`,
        {
          name: normalizedName
        }
      );

      if (!response.data.erro) {

        fetchBrands();

        NotificationsAlert(
          "success",
          "",
          response.data.msg
        );

        return;
      }

    } catch (error) {

      console.error("Error:", error);

      NotificationsAlert(
        "danger",
        "",
        error?.response?.data?.msg || "Erro ao cadastrar marca"
      );
    }

    fetchBrands();
  };

  const handleSaveModelo = async ({ modelo, marcaId }) => {

    const token = localStorage.getItem("fptoken");

    const normalizedModel = normalizeText(modelo);

    /* VALIDAÇÃO */
    const alreadyExists = models.some(
      (model) =>
        model.brand_id === Number(marcaId) &&
        normalizeText(model.description) === normalizedModel
    );

    if (alreadyExists) {

      NotificationsAlert(
        "warning",
        "",
        "Este modelo já está cadastrado para esta marca."
      );

      return;
    }

    try {

      const response = await Conect.post(
        `/createmodelvehicle${token}`,
        {
          description: normalizedModel,
          brand_id: marcaId
        }
      );

      if (!response.data.erro) {

        fetchModels(marcaId);

        NotificationsAlert(
          "success",
          "",
          response.data.msg
        );

        return;
      }

    } catch (error) {

      console.error("Error:", error);

      NotificationsAlert(
        "danger",
        "",
        error?.response?.data?.msg || "Erro ao cadastrar modelo"
      );
    }

    fetchModels(marcaId);
  };

  const handleDeleteModel = async (id, marcaId) => {
    const token = localStorage.getItem("fptoken");
    try {
      const response = await Conect.delete(`/deletemodelvehicle${id}/${token}`)
      if (!response.data.erro) {
        fetchModels(marcaId);
        NotificationsAlert("default", "", response.data.msg);
        return;
      }

    } catch (error) {
      console.error("Error:", error);
      NotificationsAlert("danger", "", error.data.msg);
    }
    fetchModels(marcaId);
  };

  const handleFilterByBrand = (brandId) => {
    if (brandId === "") {
      setSelectedBrand(null);
      fetchModels("all"); // busca todos os modelos
    } else {
      const selected = brands.find(b => b.id === parseInt(brandId));
      setSelectedBrand(selected);
      fetchModels(brandId); // busca modelos da marca selecionada
    }
  };

  const normalizeText = (text) => {
    return text
      ?.trim()
      ?.replace(/\s+/g, ' ')
      ?.toUpperCase();
  };

  return (
    <div className="bm-container">

      {/* HEADER */}
      <div className="bm-page-header">
        <div>
          <h1>Marcas & Modelos</h1>
          <p>Gerencie marcas e modelos cadastrados no sistema</p>
        </div>

        <button
          className="bm-refresh-btn"
          onClick={() => fetchBrands()}
        >
          <LuRefreshCcw size={16} />
          Atualizar
        </button>
      </div>

      {/* GRID */}
      <div className="bm-grid">

        {/* MARCAS */}
        <div className="bm-card">

          <div className="bm-card-header">
            <div>
              <h2>Marcas</h2>
              <span>{brands.length} cadastradas</span>
            </div>

            <button
              className="bm-add-btn"
              onClick={() => setShowModalMarca(true)}
            >
              + Nova Marca
            </button>
          </div>

          <div className="bm-list-container">

            {brands.length > 0 ? (
              <ul className="bm-list">
                {brands.map((brand) => (
                  <li
                    key={brand.id}
                    className={`bm-item ${selectedBrand?.id === brand.id ? 'active' : ''
                      }`}
                    onClick={() => setSelectedBrand(brand)}
                  >
                    <div className="bm-item-content">
                      <div className="bm-item-avatar">
                        {brand.name?.charAt(0)}
                      </div>

                      <div className="bm-item-info">
                        <strong>{normalizeText(brand.name)}</strong>
                        <span>ID #{brand.id}</span>
                      </div>
                    </div>

                    <div className="bm-item-arrow">
                      →
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="bm-empty">
                Nenhuma marca cadastrada
              </div>
            )}

          </div>
        </div>

        {/* MODELOS */}
        <div className="bm-card">

          <div className="bm-card-header">

            <div>
              <h2>Modelos</h2>
              <span>{models.length} cadastrados</span>
            </div>

            <div className="bm-actions">

              <select
                className="bm-select"
                onChange={(e) => handleFilterByBrand(e.target.value)}
                value={selectedBrand?.id || ''}
              >
                <option value="">
                  Todas as marcas
                </option>

                {brands.map((brand) => (
                  <option key={brand.id} value={brand.id}>
                    {brand.name}
                  </option>
                ))}
              </select>

              <button
                className="bm-add-btn"
                onClick={() => setShowModalModelo(true)}
              >
                + Modelo
              </button>

            </div>
          </div>

          <div className="bm-list-container">

            {models.length > 0 ? (
              <ul className="bm-list">
                {models.map((model) => (
                  <li
                    key={model.id}
                    className="bm-item"
                  >

                    <div className="bm-item-content">

                      <div className="bm-item-avatar model">
                        {model.description?.charAt(0)}
                      </div>

                      <div className="bm-item-info">
                        <strong>{normalizeText(model.description)}</strong>

                        <span>
                          {brands.find(
                            (b) => b.id === model.brand_id
                          )?.name || 'Marca'}
                        </span>
                      </div>

                    </div>

                    <button
                      className="bm-delete-btn"
                      onClick={() =>
                        handleDeleteModel(
                          model.id,
                          model.brand_id
                        )
                      }
                    >
                      Excluir
                    </button>

                  </li>
                ))}
              </ul>
            ) : (
              <div className="bm-empty">
                Nenhum modelo encontrado
              </div>
            )}

          </div>
        </div>

      </div>

      {/* Modais */}
      <ModalCadastroMarca
        isOpen={showModalMarca}
        onClose={() => setShowModalMarca(false)}
        onSave={handleSaveMarca}
      />

      <ModalCadastroModelo
        isOpen={showModalModelo}
        onClose={() => setShowModalModelo(false)}
        onSave={handleSaveModelo}
        marcas={brands}
        setSelectedBrand={setSelectedBrand}
        selectedBrand={selectedBrand}
      />

    </div>
  );
};

export default BrandsModelsManager;
